export const RESET = 'EXCMREGIONUSERDATA_LIST_RESET'
export const SET_ITEMS = 'EXCMREGIONUSERDATA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMREGIONUSERDATA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMREGIONUSERDATA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMREGIONUSERDATA_LIST_TOGGLE_LOADING'
